import { InviteUserRole } from '@models/Invite.model';

interface IGetPermissionData {
  action: 'add' | 'edit' | 'delete' | 'favorite' | 'status' | 'assignee';
  owner: boolean;
  role: InviteUserRole;
  type: string;
}

interface IResponse {
  allowed: boolean;
  message: string;
}

export const getPermissionData = ({
  owner,
  role,
  type,
  action,
}: IGetPermissionData): IResponse => {
  if (action === 'assignee') {
    if ([InviteUserRole.ADMIN, InviteUserRole.EDITOR].includes(role)) {
      return {
        allowed: true,
        message: '',
      };
    }

    return {
      allowed: false,
      message: 'You currently do not have<br />permission to change assignee',
    };
  }

  if (action === 'status') {
    if (![InviteUserRole.VIEWER].includes(role)) {
      return {
        allowed: true,
        message: '',
      };
    }

    return {
      allowed: false,
      message: 'You currently do not have<br />permission to change status',
    };
  }

  if (action === 'favorite') {
    if (![InviteUserRole.VIEWER].includes(role)) {
      return {
        allowed: true,
        message: '',
      };
    }
  }

  if (!owner) {
    return {
      allowed: false,
      message: `OEM ${type} cannot be<br />edited or deleted`,
    };
  }

  if ([InviteUserRole.MEMBER].includes(role)) {
    if (['add', 'delete'].includes(action)) {
      return {
        allowed: false,
        message: `You currently do not have<br />permission to ${action} items`,
      };
    }
  }

  if ([InviteUserRole.VIEWER].includes(role)) {
    return {
      allowed: false,
      message: `You currently do not have<br />permission to ${action} items`,
    };
  }

  return {
    allowed: true,
    message: '',
  };
};
